import styled from 'styled-components'
import { COLOR, FONT_SIZE, NATIVE_BASE_COLORS } from '../../../themes'
import { hexToRgba } from '../../../helpers'
const Style = styled.div`
  .svg_tooltip_text,
  .text-svg {
    stroke-width: 0px;
    font-family: NunitoBold;
    font-size: ${FONT_SIZE.XXS};
    fill: ${COLOR.BLACK_1};
  }
  .svg_tooltip_rect {
    stroke-width: 1;
    stroke: ${COLOR.GOLD_1};
  }
  #linkOverlay{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: visible;
  }
  .available polygon,
  .busy polygon {
    transition: fill 0.2s ease, filter 0.2s ease;
  }
  .available polygon {
    fill: ${hexToRgba(NATIVE_BASE_COLORS.TEXT[300], 0.5)};
    stroke: none;
  }
  .busy polygon {
    fill: var(--busy-fill);
    stroke: none;
    fill-opacity: 1;
  }
  .available.is-hovered polygon {
    fill: ${hexToRgba('#B4B4B4', 0.8)};
  }
  .busy.is-hovered polygon {
    fill: var(--busy-fill-hover);
    filter: brightness(0.85);
  }
  .room-label {
    overflow: visible;
  }
  .pointer {
    cursor: pointer;
  }
`

export default Style

